import { render, staticRenderFns } from "./ScheduledMessagesList.vue?vue&type=template&id=2622b388&scoped=true&"
import script from "./ScheduledMessagesList.vue?vue&type=script&lang=js&"
export * from "./ScheduledMessagesList.vue?vue&type=script&lang=js&"
import style0 from "./ScheduledMessagesList.vue?vue&type=style&index=0&id=2622b388&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2622b388",
  null
  
)

export default component.exports